export default __webpack_public_path__ + "static/media/emandate-inprocess.7943a19d.svg";